/*
    RSSMOD-906: https://jira.westat.com/browse/RSSMOD-906
    RSSMOD-907: https://jira.westat.com/browse/RSSMOD-907
    This component creation done on the requirement of above jira.
*/
import React from 'react';
import {
    ProtocolNumSelector,
    ProtocolIdSelector,
    lSelectorGetProtDetails,
    eSelectorGetProtDetails,
    ProtocolProcessStatusSelector
} from 'selectors';
import { compose } from 'recompose';
import atoms from 'ctsutheme/components/atoms';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RenderControl } from 'components/RenderHelpers';
import { withAppContext } from '@ctsu/loader';
import { bindLogger } from 'helpers/BindLogger';
import { TE, httpStatusEnum } from 'appconstants';
import { openModal } from 'actions/common';
import { triggerProtocolProcessStatus } from 'actions/protocols/administration';
import { FormLayoutHeader } from 'components/FormHelpersPlain';
import {
    CanUserStatusProcess, CanUserAccessAdmin
} from 'appconstants/Permission';

const { Button } = atoms;

const AdminOtherActions = props => {
    const {
        isLoadingPrtDetails,
        iserrorPrtDetails,
        onOpenModal,
        protocolId,
        protocolNumber,
        isProcessSelector,
        context,
        onTiggerStatusProcess
    } = props;

    const processHandler = () => {
        bindLogger(onTiggerStatusProcess, context)(protocolId,
            {}).subscribe(resp => {
                if (resp.status === httpStatusEnum.SUCCESS) {
                    onOpenModal({
                        data: protocolNumber,
                        type: "ProcessStatusChange",
                        title: "Immediate Processing Requested"
                    });
                }
            });
    };

    const disableStatus = () => !(CanUserStatusProcess() && isProcessSelector === true);

    return (
        <div className="form-layout-wrapper mb-3" data-id="accuralInfoTitle">
            <FormLayoutHeader title="Status Change Processing">
                <div className="d-flex row">
                    <RenderControl
                        isLoading={isLoadingPrtDetails}
                        iserror={iserrorPrtDetails}
                        compName="Process Status Change Now"
                        permission={CanUserAccessAdmin()}
                    >
                        <Button
                            variant="outlined"
                            color="primary"
                            name="processStatusChange"
                            disabled={disableStatus()}
                            data-id={`${TE.ID}process_status_change${TE.BTN}`}
                            onClick={processHandler}
                            className="turquoise"
                        >
                            Process Status Change Now
                        </Button>
                    </RenderControl>
                </div>
            </FormLayoutHeader>
        </div>
    );
};

AdminOtherActions.propTypes = {
};

AdminOtherActions.defaultProps = {
    context: null
};

const withConnectState = connect(
    (state, ownProps) => ({
        protocolNumber: ProtocolNumSelector(state),
        protocolId: ProtocolIdSelector(state),
        isLoadingPrtDetails: lSelectorGetProtDetails(state),
        iserrorPrtDetails: eSelectorGetProtDetails(state),
        isProcessSelector: ProtocolProcessStatusSelector(state)
    }),
    dispatch => bindActionCreators(
        {
            onOpenModal: openModal,
            onTiggerStatusProcess: triggerProtocolProcessStatus
        },
        dispatch
    )
);

const AdminOtherActionsContainer = compose(
    withConnectState,
    withAppContext
)(AdminOtherActions);

export default AdminOtherActionsContainer;
